import { Button, Tooltip } from '@mui/material';

import { ADMINS_MA_DEALS_PATH } from '@/utils/constants';
import { formatDateAsDayMonthYear } from '@/utils/dateFormatter';
import { GridColDef } from '@mui/x-data-grid';

export const TABLE_COLUMNS: GridColDef[] = [
  {
    field: 'effectiveDate',
    headerName: 'Effective Date',
    width: 150,
    renderCell: (params) => formatDateAsDayMonthYear(params.value) || '-',
  },
  {
    field: 'dealType',
    headerName: 'Deal Type',
    width: 150,
  },
  {
    field: 'dealCountryName',
    headerName: 'Country Name',
    width: 150,
    renderCell: (params) => params.value || 'Multiple Countries',
  },
  {
    field: 'dealBuyerCompanyName',
    headerName: 'Buyer Company',
    width: 150,
    renderCell: (params) => params.value || 'Multiple Buyers',
  },
  {
    field: 'dealSellerCompanyName',
    headerName: 'Seller Company',
    width: 150,
    renderCell: (params) => params.value || 'Multiple Sellers',
  },
  {
    field: 'dealAssetName',
    headerName: 'Asset Name',
    width: 150,
    renderCell: (params) => params.value || 'Multiple Assets',
  },
  {
    field: 'comment',
    headerName: 'Comment',
    width: 250,
    renderCell: (params) => (
      <Tooltip title={params.value} placement="bottom-start">
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: 'actions',
    headerName: '',
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    flex: 1,
    align: 'center',
    renderCell: (params) => (
      <Button
        sx={{ borderRadius: '2em', padding: '0.5em 2em', maxHeight: 'fit-content' }}
        variant="contained"
        color="secondary"
        href={`${ADMINS_MA_DEALS_PATH}/${params.row.id}`}
      >
        Edit
      </Button>
    ),
  },
];
